import {useTranslation} from 'react-i18next';
import {ChekinLogo, cn} from '@chekinapp/ui';
import {LocaleButton} from 'components/LanguageButton';
import {TOP_BAR_GLASS_CLASS} from 'components/MobileTopBar/topBarGlass';

function SceneHeader() {
  const {t} = useTranslation();

  return (
    <>
      <header
        className={cn(
          'sticky top-[var(--maintenance-banner-height,0px)] z-20 flex items-center gap-3 border-b border-[var(--chekin-divider-subtle)] px-3.5 py-2.5 lg:hidden',
          TOP_BAR_GLASS_CLASS,
        )}
      >
        <ChekinLogo markOnly plate size="sm" />
        <div className="flex min-w-0 flex-1 flex-col">
          <span className="text-[15px] font-bold leading-[1.25] text-[color:var(--chekin-text-primary)]">
            {t('chekin_brand')}
          </span>
          <span className="text-xs font-medium text-[color:var(--chekin-text-secondary)]">
            {t('splash_secure_check_in')}
          </span>
        </div>
        <LocaleButton
          variant="link"
          display="code"
          className="px-1 py-1.5 text-[13px] font-medium text-[color:var(--chekin-text-secondary)]"
        />
      </header>

      <ChekinLogo
        plate
        size="lg"
        className="absolute left-[30px] top-[26px] hidden lg:inline-flex"
      />
      <LocaleButton
        variant="outline"
        className="absolute right-[30px] top-[30px] hidden lg:inline-flex"
      />
    </>
  );
}

export {SceneHeader};
